import {alpha, SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const toolbarSx: SxProps<Theme> = {
    '&.MuiToolbar-root': {
        marginTop: theme.spacing(50 / 8),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(10 / 8),
        alignItems: 'flex-start',
        paddingLeft: 0,
        paddingRight: 0,
    },
};
export const prominentLinkSx = () => ({
    display: 'flex',
    width: '100%',
    padding: 0,
    marginBottom: theme.spacing(4 / 8),
    '& a': {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(10 / 8),
        color: theme.palette.common.white,
        fill: theme.palette.common.white,
        padding: theme.spacing(12 / 8, 14 / 8),
        width: '100%',
        borderRadius: theme.spacing(8 / 8),
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #007FDC 0%, #28419D 50%, #821F9B 100%)',
        boxShadow: '0 4px 16px rgba(0, 127, 220, 0.35), 0 0 0 1px rgba(255,255,255,0.08) inset',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            borderRadius: 'inherit',
            padding: '1px',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.3), transparent 40%, transparent 60%, rgba(255,255,255,0.15))',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude',
            pointerEvents: 'none',
        },
        '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 6px 20px rgba(0, 127, 220, 0.5), 0 0 0 1px rgba(255,255,255,0.12) inset',
            background: 'linear-gradient(135deg, #1D8FE8 0%, #3451A8 50%, #9329AD 100%)',
        },
        '&.active': {
            background: 'linear-gradient(135deg, #0066B0 0%, #1E3585 50%, #6D1A85 100%)',
            boxShadow: '0 2px 8px rgba(0, 127, 220, 0.25), 0 0 0 1px rgba(255,255,255,0.2) inset',
        },
        '&.active svg, & svg': {
            fill: theme.palette.common.white,
        },
        '& .ai-chip': {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(0, 6 / 8),
            minWidth: 28,
            height: 22,
            borderRadius: theme.spacing(4 / 8),
            background: alpha('#fff', 0.28),
            color: theme.palette.common.white,
            fontSize: '0.8rem',
            fontWeight: 900,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            backdropFilter: 'blur(4px)',
            border: `1px solid ${alpha('#fff', 0.18)}`,
            flexShrink: 0,
            lineHeight: 1,
            animation: 'aiChipPulse 2.8s ease-in-out infinite',
        },
        '@keyframes aiChipPulse': {
            '0%, 100%': {
                boxShadow: `0 0 0 0 ${alpha('#fff', 0.35)}`,
            },
            '50%': {
                boxShadow: `0 0 0 4px ${alpha('#fff', 0)}`,
            },
        },
    },
});

export const linkSx = (withoutHightlight = false) => ({
    display: 'flex',
    width: '100%',
    padding: 0,
    '& a': {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(10 / 8),
        color: theme.palette.neutral[500],
        fill: theme.palette.neutral[500],
        padding: theme.spacing(12 / 8, 14 / 8),
        width: '100%',
        borderRadius: theme.spacing(4 / 8),
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
            background: alpha('#000', 0.24),
        },
        '&.active': {
            color: !withoutHightlight ? theme.palette.brand.main : theme.palette.neutral[500],
            background: !withoutHightlight ? alpha('#1000', 0.24) : 'transparent',
        },
        '&.active svg': {
            fill: !withoutHightlight ? theme.palette.brand.main : theme.palette.neutral[500],
        },
        '& .MuiBox-root': {
            position: 'absolute',
            left: '20px',
            top: '15px',
            transform: 'translateY(-50%)',
            transition: '0.3s ease-in',
        },
    },
});
